import * as actions from './actions';

const INITIAL_STATE = {
    initialised: false,
    data: null,
    fetching: false,
    error: null,
    useDollars: false,
    sorting: [],
    timeLastUpdated: null
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case actions.SET_INITIALISED:
            return {
                ...state,
                initialised: true
            };
        case actions.FETCH_IM_MONITORING_REQUEST:
            return {
                ...state,
                fetching: true,
                error: INITIAL_STATE.error
            };
        case actions.FETCH_IM_MONITORING_SUCCESS:
            return {
                ...state,
                data: action.data,
                fetching: false,
                error: INITIAL_STATE.error,
                timeLastUpdated: action.timestamp
            };
        case actions.FETCH_IM_MONITORING_ERROR:
            return {
                ...state,
                fetching: false,
                error: action.message
            };
        case actions.SWITCH_CURRENCIES:
            return {
                ...state,
                useDollars: !state.useDollars
            };
        case actions.SET_SORTING:
            return {
                ...state,
                sorting: action.sorting
            };
        default:
            return state;
    }
};
